import React, { Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import MenuBar from '../MenuBar/MenuBar';
import { Wrapper, Content } from './style';
import layoutObj from './layoutObj';
import Header from '../Header/Header';

const Layout = ({ backdropState, toggleGralBKdrop }) => (
  <Wrapper>
    <Header />
    <MenuBar />
    <Content>
      <Switch>
        <Suspense fallback="">
          {layoutObj.map(({ route, component }) => (
            <Route path={route} exact component={component} />
          ))}
          <Route path="/" exact render={() => <Redirect to="/introduction" />} />
        </Suspense>
      </Switch>
    </Content>
  </Wrapper>
);

export default Layout;
